import React, { Component, Fragment } from 'react';
import './EmptyCardItem.module.scss';

//import Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Draggable, Droppable } from 'react-beautiful-dnd';

class EmptyCardItem extends Component {

    constructor() {
        super();
        this.handleClick                = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.order);
    }

    render() {
        return (
            <div onClick={this.handleClick} styleName={'carditem-background ' + (this.props.draggingASchedule ? ' dragging ' : '') + (this.props.weekend ? 'weekend ' : '')} > </div>
        );
    }

}


export default EmptyCardItem;